import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useGlobalContent } from '../../../hooks';
import OrderDelivery from '../../Order/OrderDelivery';

const ShippingInformation = ({ title, methodType, delivery, className }) => {
  const { deliveryDateLabel, methods } = useGlobalContent('orders');
  const { label = `Missing translation for "${methodType}"` } = methods.find(shippingMethod =>
    shippingMethod.type === methodType
  ) || {};

  return (
    <div className={cx('shipping-method', {
      [className]: className
    })}>
      <h5 className="text-kilo bold">{title}</h5>
      <h6 className="text-kilo bold color-green">{label}</h6>
      <OrderDelivery label={deliveryDateLabel} delivery={delivery} />
    </div>
  );
};

ShippingInformation.propTypes = {
  title: PropTypes.string.isRequired,
  methodType: PropTypes.string.isRequired,
  delivery: PropTypes.shape({
    latest: PropTypes.string.isRequired,
    earliest: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};


export default ShippingInformation;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderDetails/ShippingInformation/ShippingInformation.js